import { render, staticRenderFns } from "./ThermoCompo.vue?vue&type=template&id=c077eda6&scoped=true&"
import script from "./ThermoCompo.vue?vue&type=script&lang=js&"
export * from "./ThermoCompo.vue?vue&type=script&lang=js&"
import style0 from "./ThermoCompo.vue?vue&type=style&index=0&id=c077eda6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c077eda6",
  null
  
)

export default component.exports